import { Component, OnInit, AfterContentChecked, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Email } from './../../../../../assets/smtp.js';
import { ToastrService } from 'ngx-toastr';
import { DOCUMENT } from '@angular/common';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit, AfterContentChecked {

  public show: boolean = false;
  isCaptchaHidden: boolean = false;
  isNoopenAttributeSet: boolean = false;
  //siteKey = "6LctkNUZAAAAAM8FK0DohSDnwcsZSQgsY-MlJ7MD"; // for developing (localhost)
  siteKey = "6LfhjtUZAAAAAAWZadSPJQyJSIm1eS59XbbcgdEv"; // for production
  private language: string = document.URL.split('/')[3];
  policyLink = this.language + "/policy";

  firstFormGroup: FormGroup;

  constructor(@Inject(DOCUMENT) private dom: Document,
    private toastr: ToastrService,
    private _formBuilder: FormBuilder) {

  }

  ngOnInit() {
    this.firstFormGroup = this._formBuilder.group({
      nameCtrl: ['', [Validators.required]],
      emailCtrl: ['', [Validators.required, Validators.email]],
      aboutCtrl: ['', [Validators.required, Validators.maxLength(500)]],
      captchaCtrl: ['', [Validators.required]]
    });
  }

  ngAfterContentChecked() {
    if (this.firstFormGroup.controls["nameCtrl"].valid &&
      this.firstFormGroup.controls["emailCtrl"].valid &&
      this.firstFormGroup.controls["aboutCtrl"].valid) {
      this.dom.getElementById('hide-captcha').style.setProperty("display", "flex");
    }
    else {
      if (!this.isCaptchaHidden) {
        let captcha = this.dom.getElementById('hide-captcha');
        captcha.style.setProperty("display", "none", "important");
        this.isCaptchaHidden = true;
      }
    }

    if (!this.isNoopenAttributeSet) {
      let links = this.dom.querySelectorAll('a.at300b');
      if (links.length == 4) {
        links.forEach(link => {
          link.setAttribute('rel', 'noopener');
        })
        this.isNoopenAttributeSet = true;
      }
    }
  }

  onSubmit(f: FormGroup) {
    this.isCaptchaHidden = false;
    Email.send({
      Host: 'smtp.elasticemail.com',
      Username: 'owner@customsolutions.info',
      Password: '3E829C5D585B36117614FD683054A24B3FC5',
      To: 'info@customsolutions.info',
      From: 'owner@customsolutions.info',
      Subject: 'Feedback form - Have Any Questions?',
      Body: `
      <b>Name: </b>${this.firstFormGroup.controls["nameCtrl"].value} <br/><b>Email: </b>${this.firstFormGroup.controls["emailCtrl"].value}<br/> 
      <b>Message: </b><br/>${this.firstFormGroup.controls["aboutCtrl"].value}<br/>
      <b>~End of Message~</b>`
    }).then(message => {
      let answerFromSmtp = message as string;
      if (answerFromSmtp.toLocaleLowerCase() == 'ok') {
        this.toastr.success('Email was sent successfully!', 'Sending Email', {
          timeOut: 2400,
          progressBar: true,
        });
      }
      else {
        this.toastr.error(answerFromSmtp, 'Sending Email', {
          timeOut: 3500,
          progressBar: true,
        });
      }
      f.reset();
    });
  }
}
